const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const PackByIdReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_PACK_DETAIL_ID_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_PACK_DETAIL_ID_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_PACK_DETAIL_ID_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      case "CLEAR_PACK_DETAIL_ID":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: null,
        };
      default:
        return state;
    }
  };
  
  export default PackByIdReducer;